import { computed, decorate, observable } from "mobx"

export const POPUPS_IDS = {
  GOALS: "GOALS",
  ALEAS: "ALEAS",
  REPORT: "REPORT",
  MYFARM: "MYFARM",
  AEPS: "AEPS",
  ADVISOR: "ADVISOR",
  TREES: "TREES",
  PROFILE: "PROFILE",
  JAUGES: "JAUGES",
  GAME_OVER: "GAME_OVER",
  IND_HISTORY: "IND_HISTORY",
  MEETING_OVERLAY: "MEETING_OVERLAY",
  DESCRIPTION: "DESCRIPTION",
  NEW_GAME_ALERT: "NEW_GAME_ALERT"
}




class Popup {
  id = null
  data = null

  constructor(id, data = null) {
    this.id = id
    this.data = data
  }

}


class PopupStore {

  list = []
  groups = [
    [POPUPS_IDS.GOALS, POPUPS_IDS.ALEAS],
    [POPUPS_IDS.PROFILE, POPUPS_IDS.REPORT, POPUPS_IDS.MYFARM]
  ]

  constructor() {
    window.addEventListener("keydown", e => {
      if(e.code === "Escape") {
        this.closeLastPopup()
      }
    })
  }

  getGroup(popup_id) {
    let group = this.groups.find(g => g.indexOf(popup_id) > -1)
    if(!group) group = [popup_id]
    return group
  }

  open(popupId, data = null) {
    if(this.isOpened(popupId)) return
    this.list.push(new Popup(popupId, data))
  }

  close(popupId) { this.list = this.list.filter(p => p.id !== popupId) }
  closeLastPopup() { this.list.pop() }
  closeAll() { this.list = [] }

  toggle(popupId) {
    let isOp = this.isOpened(popupId)

    this
    .getGroup(popupId)
    .forEach(pid => this.close(pid))

    if(!isOp) this.open(popupId)



  }

  isOpened(popupId) { return this.get(popupId) !== undefined }

  get(popupId) { return this.list.find(p => p.id === popupId) }

  // MEETING OVERLAY (shortcut + simple)
  showMeetingOverlay(show = true) {
    if(show){
      this.open(POPUPS_IDS.MEETING_OVERLAY)
    }
    else {
      this.close(POPUPS_IDS.MEETING_OVERLAY)
    }
  }



}

decorate(PopupStore, {
  list: observable
})

export default new PopupStore()